import { DashboardData } from '@/types/dashboard';

export const mockDashboardData: DashboardData = {
  stats: {
    totalClients: {
      value: 142,
      change: 12.5,
      isPositive: true,
    },
    activeProjects: {
      value: 23,
      change: 8.3,
      isPositive: true,
    },
    revenueThisMonth: {
      value: 84500,
      change: -3.2,
      isPositive: false,
    },
    hoursLogged: {
      value: 487,
      change: 15.7,
      isPositive: true,
    },
  },
  charts: {
    revenue: [
      { month: 'Aug', revenue: 65000, target: 70000 },
      { month: 'Sep', revenue: 72000, target: 75000 },
      { month: 'Oct', revenue: 68000, target: 75000 },
      { month: 'Nov', revenue: 78000, target: 80000 },
      { month: 'Dec', revenue: 82000, target: 85000 },
      { month: 'Jan', revenue: 84500, target: 87000 },
    ],
    projectStatus: [
      { name: 'In Progress', value: 12, color: '#4F46E5' },
      { name: 'Planning', value: 5, color: '#9CA3AF' },
      { name: 'On Hold', value: 3, color: '#F59E0B' },
      { name: 'Completed', value: 3, color: '#10B981' },
    ],
    timeTracking: [
      { project: 'Website Redesign', hours: 124, budget: 160 },
      { project: 'Mobile App', hours: 98, budget: 120 },
      { project: 'Brand Identity', hours: 76, budget: 80 },
      { project: 'Marketing Campaign', hours: 52, budget: 60 },
      { project: 'E-commerce Platform', hours: 137, budget: 200 },
    ],
    clientAcquisition: [
      { month: 'Aug', clients: 8 },
      { month: 'Sep', clients: 12 },
      { month: 'Oct', clients: 10 },
      { month: 'Nov', clients: 15 },
      { month: 'Dec', clients: 18 },
      { month: 'Jan', clients: 14 },
    ],
  },
  activities: [
    {
      id: '1',
      type: 'contract',
      title: 'Contract Signed',
      description: 'TechCorp Inc. signed the Q1 development contract',
      timestamp: new Date(Date.now() - 1000 * 60 * 15).toISOString(),
      entityId: 'client-123',
      entityType: 'client',
    },
    {
      id: '2',
      type: 'project',
      title: 'Project Started',
      description: 'E-commerce platform development kicked off',
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(),
      entityId: 'project-456',
      entityType: 'project',
    },
    {
      id: '3',
      type: 'payment',
      title: 'Payment Received',
      description: '$25,000 received from GlobalTech Solutions',
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 5).toISOString(),
      entityId: 'client-789',
      entityType: 'client',
    },
    {
      id: '4',
      type: 'client',
      title: 'New Client Added',
      description: 'Innovate Labs joined as a new client',
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 8).toISOString(),
      entityId: 'client-101',
      entityType: 'client',
    },
    {
      id: '5',
      type: 'time',
      title: 'Time Entry Logged',
      description: 'Roman logged 8 hours on Mobile App project',
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 12).toISOString(),
      entityId: 'project-202',
      entityType: 'project',
    },
    {
      id: '6',
      type: 'project',
      title: 'Milestone Completed',
      description: 'Website Redesign Phase 2 completed',
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 24).toISOString(),
      entityId: 'project-303',
      entityType: 'project',
    },
    {
      id: '7',
      type: 'contract',
      title: 'Proposal Sent',
      description: 'Brand refresh proposal sent to RetailCo',
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 36).toISOString(),
      entityId: 'proposal-404',
      entityType: 'proposal',
    },
    {
      id: '8',
      type: 'other',
      title: 'Meeting Scheduled',
      description: 'Client review meeting set for next Tuesday',
      timestamp: new Date(Date.now() - 1000 * 60 * 60 * 48).toISOString(),
    },
  ],
};
